/* Collection card video (snippets/product-grid-item--alt.liquid)
   Desktop (hover-capable): play on hover, pause + rewind on leave.
   Touch: play/pause button in the bottom right corner. */
(function () {
  if (customElements.get("collection-card-video")) return;

  var canHover = window.matchMedia("(hover: hover) and (pointer: fine)");

  class CollectionCardVideo extends HTMLElement {
    connectedCallback() {
      if (this._init) return;
      this._init = true;

      this.video = this.querySelector("video");
      this.toggleBtn = this.querySelector("[data-cv-toggle]");
      if (!this.video) return;

      var self = this;
      var hoverTarget = this.closest(".image-container") || this;

      hoverTarget.addEventListener("mouseenter", function () {
        if (canHover.matches) self.play();
      });
      hoverTarget.addEventListener("mouseleave", function () {
        if (canHover.matches) self.stop();
      });

      if (this.toggleBtn) {
        this.toggleBtn.addEventListener("click", function (e) {
          // Button sits inside the card link, don't navigate
          e.preventDefault();
          e.stopPropagation();
          if (self.classList.contains("is-playing")) self.pause();
          else self.play();
        });
      }

      // Only reveal the video once frames are actually rendering
      this.video.addEventListener("playing", function () {
        self.classList.add("is-active");
      });
    }

    play() {
      this.classList.add("is-playing");
      if (this.toggleBtn) this.toggleBtn.setAttribute("aria-label", "Pause video");
      this.video.muted = true;
      var p = this.video.play();
      if (p && typeof p.catch === "function") p.catch(function () {});
    }

    pause() {
      this.video.pause();
      this.classList.remove("is-playing");
      if (this.toggleBtn) this.toggleBtn.setAttribute("aria-label", "Play video");
    }

    stop() {
      this.pause();
      this.classList.remove("is-active");
      try { this.video.currentTime = 0; } catch (e) {}
    }
  }

  customElements.define("collection-card-video", CollectionCardVideo);
})();
